// src/stone/icons/Accelerator.tsx
import { jsx, jsxs } from "react/jsx-runtime";
var Accelerator = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    ...props,
    children: [
      /* @__PURE__ */ jsx("path", { d: "M11 6V3h2v3zM16.95 7.636l2.12-2.121 1.415 1.414-2.12 2.121zM5.634 9.05 3.513 6.93l1.414-1.415 2.121 2.12zM20 13h3v2h-3zM13.405 11.566l4.898-1.313.518 1.932-4.899 1.312zM4 15H1v-2h3z" }),
      /* @__PURE__ */ jsx("path", { d: "M13 13a1 1 0 1 0-2 0 1 1 0 0 0 2 0m-1-3a3 3 0 1 1 0 6 3 3 0 0 1 0-6" }),
      /* @__PURE__ */ jsx("path", { d: "M0 14C0 7.373 5.373 2 12 2s12 5.373 12 12c0 2.9-1.03 5.562-2.744 7.637l-.3.363H3.044l-.3-.363A11.95 11.95 0 0 1 0 14M12 4C6.477 4 2 8.477 2 14a9.95 9.95 0 0 0 2 6h16a9.95 9.95 0 0 0 2-6c0-5.523-4.477-10-10-10" })
    ]
  }
);
var Accelerator_default = Accelerator;

export {
  Accelerator_default
};
